import { types } from 'mobx-state-tree';

export const saveInspection = types
  .model({
    isChanged: types.boolean,
    isSaved: types.boolean,
    tempData: types.maybeNull(
      types.model({
        recommendations: types.maybeNull(types.string),
        dateCompleted: types.maybeNull(types.string),
        proxyInspector: types.maybeNull(types.string),
      }),
    ),
  })
  .views(self => ({
    get isChangedTrue() {
      return self.isChanged;
    },
    get completeInspectionData() {
      return self.tempData;
    },
  }))
  .actions(self => ({
    setIsChanged: (data: boolean) => {
      self.isChanged = data;
    },
    setIsSaved: (data: boolean) => {
      self.isSaved = data;
    },
    setDiscardData: (discardData: {
      recommendations: string;
      dateCompleted: string;
      proxyInspector: string;
    }) => {
      self.tempData = {
        recommendations: discardData.recommendations,
        dateCompleted: discardData.dateCompleted,
        proxyInspector: discardData.proxyInspector,
      };
    },
  }));

export default saveInspection;
